import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import { track } from 'shared/models/analytic';
import { isEqual } from 'shared/models/address';
import { component as Category } from 'components/category';
import Spinner from 'react-spinkit';
import { Link } from 'react-router-dom';
import ProductItem from '../productItem';
import LeadCaptureModal from '../leadCaptureModal';
import HeadTags from './head';

class CategoryGroup extends Category {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const name = this._nameFromProps(this.props);
    this.props.loadCategoryGroup(name).then(() => {
      this.loadHeader();
      this._track();
    });
  }

  componentWillReceiveProps(nextProps) {
    const prevName = this._nameFromProps(this.props);
    const nextName = this._nameFromProps(nextProps);
    const categoryGroupHasChanged = nextName !== prevName;
    const addressHasChanged = !isEqual(this.props.address, nextProps.address);

    if (categoryGroupHasChanged || addressHasChanged) {
      this.props.loadCategoryGroup(nextName).then(() => {
        this.loadHeader();
      });
    }
  }

  _nameFromProps(props) {
    return props.match.params.name || props.location.pathname.slice(1);
  }

  _track() {
    var listId = this.props.title;
    this.props.categories.forEach(category => {
      track('Product List Viewed', {
        list_id: listId,
        category: category.title,
        products: category.products.map(item => ({ product_id: item.sku_id }))
      });
    });
  }

  refresh() {
    this.props.loadCategoryGroup();
  }

  render() {
    return (
      <div className="category category-group banner-padding">
        <HeadTags
          title={this.props.title}
          categories={this.props.categories}
          url={this.props.match.url}
        />

        {this.props.loading ? (
          <div className="full-page-container">
            <Spinner spinnerName="three-bounce" />
          </div>
        ) : (
          <Fragment>
            <div className="category-header">
              <span ref={this.imageRef} className="category-header-image" />
              <div className="category-header-text">
                <span className="category-header-title text-large">
                  {this.props.title}
                </span>
                {this.props.subtitle && (
                  <span className="category-header-subtitle text-large-subtitle">
                    {this.props.subtitle}
                  </span>
                )}
              </div>
            </div>

            <div className="category-main-content products">
              <div className="category-promotion row">
                <div className="col-xs-4 col-sm-6 col-md-6 col-lg-6 section category-promotion-left">
                  <a
                    href="http://blog.sauceyapp.com"
                    style={{
                      backgroundImage: 'url(/images/home-category-blog.jpg)'
                    }}
                  >
                    Blog
                  </a>
                </div>
                <div className="row col-xs-8 col-sm-6 col-md-6 col-lg-6 category-promotion-right">
                  <div className="row col-xs-12 col-sm-12 col-md-12  col-lg-12 section category-promotion-right-top">
                    <a
                      href="/shop/#/?category=spirits_whiskey"
                      style={{
                        backgroundImage:
                          'url(/images/home-category-whiskey.jpg)'
                      }}
                    >
                      Whiskey
                    </a>
                  </div>
                  <div className="row col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 section category-promotion-bottom-left">
                      <a
                        href="/shop/#/?category=beer"
                        style={{
                          backgroundImage: 'url(/images/home-category-beer.jpg)'
                        }}
                      >
                        Beer
                      </a>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 section category-promotion-bottom-right">
                      <a
                        href="/shop/#/?category=wine_white"
                        style={{
                          backgroundImage: 'url(/images/home-category-wine.jpg)'
                        }}
                      >
                        Wine
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {this.props.categories.map(
                category =>
                  !category.products.length ? null : (
                    <div
                      key={category.tag || category.title}
                      className="category-products row products"
                    >
                      <div className="col-xs-12 col-lg-12 products-header">
                        {category.url && (
                          <Link
                            to={
                              category.url.indexOf('/') === 0
                                ? category.url
                                : '/' + category.url
                            }
                          >
                            View More <span className="icon-arrow-right" />
                          </Link>
                        )}
                        <h2>{category.title}</h2>
                      </div>
                      {category.products.map(item => (
                        <ProductItem
                          {...item}
                          category={category.title}
                          className="col-xs-6 col-sm-4 col-md-3 col-lg-2 section"
                          key={item.sku_id}
                        />
                      ))}
                    </div>
                  )
              )}
            </div>
          </Fragment>
        )}

        <LeadCaptureModal />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.categoryGroup, address: state.address };
}

export default connect(mapStateToProps, { ...actions })(CategoryGroup);



// WEBPACK FOOTER //
// ./shared/components/categoryGroup/index.js